var _circle, _circle2, _circle3, _circle4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVerified = function SvgVerified(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    fill: "#fee658"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    fill: "url(#a)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    stroke: "#fff",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 120,
    height: 120,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 60,
    fill: "#6b0707"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    stroke: "#df0024",
    strokeWidth: 4,
    d: "M96 69.1426c0 12.3929-6.5535 23.8624-17.2305 30.1543l-10.2314 6.0281c-1.5664.923-3.5098.923-5.0762 0l-10.2314-6.0281C42.5535 93.005 36 81.5355 36 69.1426V42.4912l1.4502-.4141 5.5068-1.5732c5.4873-1.5678 10.7658-3.7916 15.7207-6.623l6.3301-3.6172.9922-.5674.9922.5674 6.3301 3.6172c4.9549 2.8314 10.2334 5.0552 15.7207 6.623l5.5068 1.5732L96 42.4912z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#ff6a6a",
    strokeWidth: 4,
    d: "M92 65.1426c0 12.3929-6.5535 23.8624-17.2305 30.1543l-10.2314 6.0281c-1.5664.923-3.5098.923-5.0762 0l-10.2314-6.0281C38.5535 89.005 32 77.5355 32 65.1426V38.4912l1.4502-.4141 5.5068-1.5732c5.4873-1.5678 10.7658-3.7916 15.7207-6.623l6.3301-3.6172.9922-.5674.9922.5674 6.3301 3.6172c4.9549 2.8314 10.2334 5.0552 15.7207 6.623l5.5068 1.5732L92 38.4912z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "m98 41-4-4v4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6a6a",
    d: "m59.5 72-2.8284 2.8284L59.5 77.6569l2.8284-2.8285zm18.8284-13.1716L81.1569 56 75.5 50.3431l-2.8284 2.8285L75.5 56zM49.5 62l-2.8284 2.8284 10 10L59.5 72l2.8284-2.8284-10-10zm10 10 2.8284 2.8284 16-16L75.5 56l-2.8284-2.8284-16 16z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 4,
    x2: 124,
    y1: 4,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbe6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdb4d",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVerified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "verified.9779bc3009e646d09f521266f946c5e9.svg";